import React, { PureComponent } from 'react';
import { CancelToken } from 'axios';
import { Helmet } from 'react-helmet';
import { parse } from 'qs';
import { WidgetMunicipal8d } from '../../widgets/Municipal8d/WidgetMunicipal8d';
import API from '../../utils/api';
import {
    getLocationData,
    celsiusToFahrenheit,
    validateColor,
    consoleLogError,
    formatDateUi,
} from '../../utils/utils';
import { EST_CEL, PROB_PREC, TEMP_MAX, TEMP_MIN } from '../../utils/variables';
import { translate } from '../../utils/translations';
import { DEFAULT_CONFIG, WIDGETS_PADDING, SUFFIXES } from '../../utils/globals';
import Loader from '../../partials/Loader/Loader';
import { PropTypes } from 'prop-types';

class Municipal8d extends PureComponent {
    state = {
        config: buildMunicipal8dConfig({}),
        data: {},
        cities: [],
        widgetDate: '',
    };

    static propTypes = {
        preview: PropTypes.bool,
        color: PropTypes.string,
        language: PropTypes.string,
        target: PropTypes.string,
        alternativeTitle: PropTypes.string,
        type: PropTypes.string,
        tempFormat: PropTypes.string,
    };

    render() {
        if (this.state.config && this.state.data && this.state.cities) {
            return (
                <div
                    className="Municipal8d main-wrapper"
                    style={WIDGETS_PADDING}
                >
                    <Helmet>
                        <title>
                            {translate(
                                this.state.config.language,
                                'municipal_8d_title'
                            )}
                        </title>
                    </Helmet>
                    <WidgetMunicipal8d
                        config={this.state.config}
                        data={this.state.data}
                        cities={this.state.cities}
                        preview={this.props.preview}
                        widgetDate={this.state.widgetDate}
                    />
                </div>
            );
        } else {
            return <Loader language={this.state.config.language} />;
        }
    }

    componentDidMount() {
        this.feedWidget();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props !== prevProps) {
            this.feedWidget();
        }
    }

    componentWillUnmount() {
        this.cancelTokenSource.cancel(
            translate(this.state.config.language, 'cancelled_request')
        );
    }

    feedWidget = () => {
        const {
            alternativeTitle,
            color,
            language,
            type,
            location,
            tempFormat,
            preview,
            target,
        } = this.props;

        const search = location ? location.search : '';
        let config = {};

        // From Configurador form
        if (preview === true) {
            config = {
                alternativeTitle,
                color,
                language,
                type,
                location,
                variables: [EST_CEL, TEMP_MAX, TEMP_MIN, PROB_PREC],
                tempFormat,
                target,
            };
        } else {
            // Or from Query String
            let querySearch = search.split('"')[0].split('%22')[0];
            //.split('%20')[0];
            config = buildMunicipal8dConfig(
                parse(querySearch, {
                    ignoreQueryPrefix: true,
                })
            );
        }

        this.cancelTokenSource = CancelToken.source();

        this.setState({ config });

        this.getData(config);
        this.getCities(config);
    };

    formatData = data => {
        let i = 0;
        let outputData = {};

        // Widget Date
        const widgetDate = formatDateUi(new Date(data[0].data.dataSortida));
        this.setState({ widgetDate });

        this.state.config.variables.forEach(el => {
            outputData[el] = {};
            for (let item = 1; item <= 8; item++) {
                outputData[el][item] = getLocationData(
                    this.state.config.location,
                    data[i + (item - 1)].data
                );
            }
            i += 8;
        });

        return outputData;
    };

    getData = async config => {
        try {
            let data = await API.getMunicipal8d(
                config,
                this.cancelTokenSource.token
            );
            data = this.formatData(data);

            // Transform to Fahrenheit if needed
            if (this.props.tempFormat === SUFFIXES.temperature.fahrenheit) {
                for (let item = 1; item <= 8; item++) {
                    data.temp_max[item][0].valor = celsiusToFahrenheit(
                        data.temp_max[item][0].valor
                    );
                    data.temp_min[item][0].valor = celsiusToFahrenheit(
                        data.temp_min[item][0].valor
                    );
                }
            }

            this.setState({ data });
        } catch (e) {
            consoleLogError(e, this.state.config.language);
        }
    };

    getCities = async config => {
        this.cancelTokenSource = CancelToken.source();
        try {
            let cities = await API.getMunicipis(this.cancelTokenSource.token);
            this.setState({ cities: cities.data });
        } catch (e) {
            consoleLogError(e, this.state.config.language);
        }
    };
}

const buildMunicipal8dConfig = ({
    location = DEFAULT_CONFIG.location,
    alternativeTitle = '',
    language = DEFAULT_CONFIG.language,
    type = DEFAULT_CONFIG.type,
    color = '',
    variables = [EST_CEL, TEMP_MAX, TEMP_MIN, PROB_PREC],
    tempFormat = '',
    target = DEFAULT_CONFIG.target,
}) => {
    color = `#${color}`;
    if (validateColor(color) === false) color = DEFAULT_CONFIG.color;
    return {
        location,
        alternativeTitle,
        language,
        type,
        color,
        variables,
        tempFormat,
        target,
    };
};

export default Municipal8d;



// WEBPACK FOOTER //
// ./src/containers/Municipal8d/Municipal8d.js